import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';

// Import client logos
import clientLogo1 from '../assets/images/client-logo1.png';
import clientLogo2 from '../assets/images/client-logo2.png';
import clientLogo3 from '../assets/images/client-logo3.png';
import clientLogo4 from '../assets/images/client-logo4.png';
import clientLogo5 from '../assets/images/client-logo5.png';

const clientLogos = [clientLogo1, clientLogo2, clientLogo3, clientLogo4, clientLogo5];

const Clients = () => {
    const { t } = useTranslation();

    return (
        <div className="float-left w-100 client-logo-con position-relative main-box" id="client">
            <Container className="wow animate__animated animate__fadeInUp" data-wow-duration="2s" data-wow-delay="0.2s">
                <div className="client-logo-inner d-flex align-items-center justify-content-between">
                    <p className="wow animate__animated animate__fadeInLeft" data-wow-duration="2s" data-wow-delay="0.2s" dangerouslySetInnerHTML={{ __html: t('clients_trusted_by') }}></p>
                    <div className="logos-con d-flex align-items-center justify-content-between">
                        {clientLogos.map((logo, index) => (
                            <figure key={index} className="wow animate__animated animate__fadeInRight" data-wow-duration="2s" data-wow-delay={`${0.6 + index * 0.4}s`}>
                                <img src={logo} alt={`client-logo-${index + 1}`} className="img-fluid" />
                            </figure>
                        ))}
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default Clients;